import React, {Component} from 'react';
import {SharedMapContextProvider} from "./contexts/SharedMapContext";
import Map from "./components/Map";
import Menu from "./components/Menu";
import {ApplicationContextProvider, ApplicationContextConsumer} from "./contexts/ApplicationContext";
import MapCloseButton from "./components/MapCloseButton";
import styled from 'styled-components';

const DesktopWrapper = styled.div` 
    position: relative;
`;

const MobileWrapper = styled.div` 
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 1500;
`;

const Wrapper = (props) => {
    return props.width > 991 ? <DesktopWrapper>{props.children}</DesktopWrapper> :
        <MobileWrapper>{props.children}</MobileWrapper>;
};

class App extends Component {

    static defaultProps = {
        center: {
            lat: 38.97649282021298,
            lng: 1.4081957353515584
        },
        zoom: 11,
        defaultType: document.getElementById('map-root').getAttribute('data-default-type'),
        height: document.getElementById('map-root').getAttribute('data-height') ? document.getElementById('map-root').getAttribute('data-height') : 550,
    };

    constructor(props) {
        super(props);
        this.state = {
            window_width: 0,
            window_height: 0,
            map_height: parseInt(props.height)
        };
        this.updateDimensions = this.updateDimensions.bind(this);
    };

    componentWillMount() {
        this.updateDimensions();
    };

    componentDidMount() {
        window.addEventListener("resize", this.updateDimensions);
    };

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    };

    updateDimensions() {
        const w = window,
            d = document,
            e = d.documentElement,
            g = d.getElementsByTagName('body')[0],
            x = w.innerWidth || e.clientWidth || g.clientWidth,
            y = w.innerHeight || e.clientHeight || g.clientHeight;
        this.setState({
            window_width: x,
            window_height: y
        });
    };

    render() {
        return (
            <ApplicationContextProvider>
                <ApplicationContextConsumer>
                    {({map_enabled, toggleMap}) => (
                        <div>
                            {map_enabled &&
                            <Wrapper width={this.state.window_width}>
                                <SharedMapContextProvider
                                    defaultType={this.props.defaultType}
                                    height={this.state.map_height}>
                                    <div className="App">
                                        <div style={{
                                            height:
                                            (this.state.window_width > 991 ? this.state.map_height : this.state.window_height)
                                            + 'px',
                                            width: '100%'
                                        }}>
                                            <Map center={this.props.center}
                                                 zoom={this.props.zoom}
                                            />
                                            <Menu/>
                                            <MapCloseButton onClick={toggleMap} width={this.state.window_width}/>
                                        </div>
                                    </div>
                                </SharedMapContextProvider>

                            </Wrapper>
                            }
                        </div>
                    )}
                </ApplicationContextConsumer>
            </ApplicationContextProvider>
        );
    }

}

export default App;
